import materiales from './moduloMateriales.json';

export type ModuloMaterialTipo = 'flyer' | 'brief';

interface ModuloMaterialFuente {
  tipo: ModuloMaterialTipo;
  label: string;
  folder: string;
  fileName: string;
}

export interface ModuloMaterialDescarga extends ModuloMaterialFuente {
  href: string;
}

const fuentes = materiales as Record<string, ModuloMaterialFuente[]>;

/** Flyer y brief generados en docs/marketing-* para un módulo del catálogo. */
export function getModuloMateriales(campo: string): ModuloMaterialDescarga[] {
  const items = fuentes[campo.trim().toUpperCase()] ?? [];
  return items.map((item) => ({
    ...item,
    href: `/material-modulos/${item.folder}/${item.fileName}`,
  }));
}
